import { useQuery } from '@apollo/client/react';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { useEffect } from 'react';
import { withTranslation } from 'react-i18next';

import Card from '../../components/Atoms/Card';
import Error from '../../components/Atoms/Error';
import Heading from '../../components/Atoms/Heading';
import Loader from '../../components/Atoms/Loader';
import UserPicture from '../../components/Atoms/UserPicture';
import UsersGrid from '../../components/Atoms/UsersGrid';
import { useCurrentUser } from '../../contexts/CurrentUserContext';
import { useLayoutInfo } from "../../hooks/useLayoutUpdate";

import GetUsersQuery from './GetUsersQuery.graphql';

const TeamView = ({ t }) => {

  const { loading, error, data } = useQuery(GetUsersQuery);

  useLayoutInfo({
    title: t('Team'), history: [{ title: t('Team') }]
  });

  const { obtainBadge } = useCurrentUser();

  useEffect(() => {
    obtainBadge('9c993668-0985-4dea-b9a3-4a946b926579');
  }, [obtainBadge]);

  if (loading && !data) return <Loader />;
  if (error) return <Error icon={faTriangleExclamation} message={t('An error occurred while loading the team.')} />;

  const users = data.users.edges;

  const admins = users.filter((u) => u.node.role === 'ADMINISTRATOR');
  const modos = users.filter((u) => u.node.role === 'MODERATOR');
  const others = users.filter((u) => u.node.role === 'USER');

  return (
    <>
      <Card>
        {admins.length > 0 && (
          <>
            <Heading h={1}>{t('The administrators')}</Heading>
            <UsersGrid>
              {admins.map((u) => (
                <UserPicture key={u.node.id} size="75px" {...u.node} />
              ))}
            </UsersGrid>
          </>
        )}
        {modos.length > 0 && (
          <>
            <Heading h={1}>{t('The moderators')}</Heading>
            <UsersGrid>
              {modos.map((u) => (
                <UserPicture key={u.node.id} size="75px" {...u.node} showBorders />
              ))}
            </UsersGrid>
          </>
        )}
        {others.length > 0 && (
          <>
            <Heading h={1}>{t('A big thanks to…')}</Heading>
            <UsersGrid>
              {others.map((u) => (
                <UserPicture key={u.node.id} size="75px" {...u.node} showBorders />
              ))}
            </UsersGrid>
          </>
        )}
      </Card>
    </>
  );
};

export default withTranslation()(TeamView);
